import React, { useState, useEffect, Fragment } from 'react'
import { Row, Col } from 'reactstrap'
import { useForm, Controller, useWatch } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { TextFieldHookForm, } from '../../../../layout/HookFormInputs'
import { checkForDecimalAndNull, checkForNull, getConfigurationKey, loggedInUserId } from '../../../../../helper'
import LossStandardTable from '../LossStandardTable'
import { saveRawMaterialCalculationForDieCasting } from '../../../actions/CostWorking'
import Toaster from '../../../../common/Toaster'
import { debounce } from 'lodash'
import TooltipCustom from '../../../../common/Tooltip'
import { number, percentageLimitValidation, checkWhiteSpaces, decimalAndNumberValidation } from "../../../../../helper/validation";
import Switch from "react-switch";


function NonFerrous(props) {
    const WeightCalculatorRequest = props.rmRowData.WeightCalculatorRequest
    const dispatch = useDispatch()

    const defaultValues = {
        castingWeight: WeightCalculatorRequest && WeightCalculatorRequest.CastingWeight !== undefined ? checkForDecimalAndNull(WeightCalculatorRequest.CastingWeight, getConfigurationKey().NoOfDecimalForInputOutput) : '',
        cavity: WeightCalculatorRequest && WeightCalculatorRequest.NumberOfCavity !== undefined ? checkForDecimalAndNull(WeightCalculatorRequest.NumberOfCavity, getConfigurationKey().NoOfDecimalForInputOutput) : '',
        yieldPercent: WeightCalculatorRequest && WeightCalculatorRequest.YieldPercent !== undefined ? checkForDecimalAndNull(WeightCalculatorRequest.YieldPercent, getConfigurationKey().NoOfDecimalForInputOutput) : '',
        shotWeight: WeightCalculatorRequest && WeightCalculatorRequest.ShotWeight !== undefined ? checkForDecimalAndNull(WeightCalculatorRequest.ShotWeight, getConfigurationKey().NoOfDecimalForInputOutput) : '',
        burningPercent: WeightCalculatorRequest && WeightCalculatorRequest.BurningPercentage !== undefined ? checkForDecimalAndNull(WeightCalculatorRequest.BurningPercentage, getConfigurationKey().NoOfDecimalForInputOutput) : '',
        burningValue: WeightCalculatorRequest && WeightCalculatorRequest.BurningValue !== undefined ? checkForDecimalAndNull(WeightCalculatorRequest.BurningValue, getConfigurationKey().NoOfDecimalForInputOutput) : '',
        recovery: WeightCalculatorRequest && WeightCalculatorRequest.RecoveryPercentage !== undefined ? checkForDecimalAndNull(WeightCalculatorRequest.RecoveryPercentage, getConfigurationKey().NoOfDecimalForInputOutput) : '',
        machiningScrapWeight: WeightCalculatorRequest && WeightCalculatorRequest.MachiningScrapWeight !== undefined ? checkForDecimalAndNull(WeightCalculatorRequest.MachiningScrapWeight, getConfigurationKey().NoOfDecimalForInputOutput) : '',
        grossWeight: WeightCalculatorRequest && WeightCalculatorRequest.GrossWeight !== undefined ? checkForDecimalAndNull(WeightCalculatorRequest.GrossWeight, getConfigurationKey().NoOfDecimalForInputOutput) : '',
        finishedWeight: WeightCalculatorRequest && WeightCalculatorRequest.FinishWeight !== undefined ? checkForDecimalAndNull(WeightCalculatorRequest.FinishWeight, getConfigurationKey().NoOfDecimalForInputOutput) : '',
        scrapWeight: WeightCalculatorRequest && WeightCalculatorRequest.ScrapWeight !== undefined ? checkForDecimalAndNull(WeightCalculatorRequest.ScrapWeight, getConfigurationKey().NoOfDecimalForInputOutput) : '',
        rmCost: WeightCalculatorRequest && WeightCalculatorRequest.RMCost !== undefined ? checkForDecimalAndNull(WeightCalculatorRequest.RMCost, getConfigurationKey().NoOfDecimalForPrice) : '',
        scrapCost: WeightCalculatorRequest && WeightCalculatorRequest.ScrapCost !== undefined ? checkForDecimalAndNull(WeightCalculatorRequest.ScrapCost, getConfigurationKey().NoOfDecimalForPrice) : '',
        materialCost: WeightCalculatorRequest && WeightCalculatorRequest.RawMaterialCost !== undefined ? checkForDecimalAndNull(WeightCalculatorRequest.RawMaterialCost, getConfigurationKey().NoOfDecimalForPrice) : '',
    }

    const [tableVal, setTableVal] = useState(WeightCalculatorRequest && WeightCalculatorRequest.LossOfTypeDetails !== null ? WeightCalculatorRequest.LossOfTypeDetails : [])
    const [lostWeight, setLostWeight] = useState(WeightCalculatorRequest && WeightCalculatorRequest.NetLossWeight ? WeightCalculatorRequest.NetLossWeight : 0)
    const [dataToSend, setDataToSend] = useState({})
    const [nonFerrousDropDown, setNonFerrousDropDown] = useState(false)
    const [isDisable, setIsDisable] = useState(false)
    const [reRender, setRerender] = useState(false)
    const [isAutoCalculateShotWeight, setIsAutoCalculateShotWeight] = useState(WeightCalculatorRequest && WeightCalculatorRequest.IsAutoCalculateShotWeight !== undefined ? WeightCalculatorRequest.IsAutoCalculateShotWeight : false)
    const { rmRowData, activeTab, isHpdc, CostingViewMode, item } = props

    // LPDC check - activeTab '2' is LPDC
    const isLpdc = activeTab === '2'
    // Combined check for features shared between HPDC and LPDC
    const isHpdcOrLpdc = isHpdc || isLpdc

    const { register, control, setValue, getValues, handleSubmit, formState: { errors }, } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: defaultValues,
    })

    const fieldValues = useWatch({
        control,
        name: ['shotWeight', 'burningPercent', 'cavity', 'finishedWeight', 'recovery', 'castingWeight', 'yieldPercent'],
    })

    const tableData = (value = []) => {

        setTableVal(value)
    }
    const LossDropDown = () => {
        let dropDown = []


        if (activeTab === '1' || activeTab === '2') {

            dropDown = [

                {
                    label: 'Melting Loss',
                    value: 9,
                },
                {
                    label: 'Fetling Loss',
                    value: 10,
                },
                {
                    label: 'Grinding Loss',
                    value: 11,
                },
                {
                    label: 'Rejection Allowance',
                    value: 12,
                },
            ]

        }
        else {
            dropDown = [
                {
                    label: 'Processing Allowance',
                    value: 13,
                },
                {
                    label: 'Machining Loss',
                    value: 14,
                },
                {
                    label: 'Rejection Allowance',
                    value: 12,
                },
            ]

        }
        setNonFerrousDropDown(dropDown)

    }
    useEffect(() => {
        if (!CostingViewMode) {
            if (isHpdcOrLpdc && isAutoCalculateShotWeight) {
                calculateShotWeight()
            }
            burningValue()
            handlGrossWeight()
            calculateRemainingCalculation(lostWeight)
        }
    }, [fieldValues, isAutoCalculateShotWeight])
    useEffect(() => {
        if (Number(getValues('finishedWeight')) < Number(getValues('castingWeight'))) {
            delete errors.finishedWeight
            setRerender(!reRender)
        }
    }, [getValues('castingWeight'), lostWeight])
    const handlGrossWeight = () => {
        const grossWeight = checkForNull(Number(getValues('castingWeight'))) + checkForNull(dataToSend?.burningValue) + lostWeight
        const updatedValue = dataToSend
        updatedValue.grossWeight = grossWeight
        setDataToSend(updatedValue)
        setValue('grossWeight', checkForDecimalAndNull(grossWeight, getConfigurationKey().NoOfDecimalForInputOutput))

    }

    const calculateRemainingCalculation = (lostSum = 0) => {
        let scrapWeight = 0
        const castingWeight = Number(getValues("castingWeight"))
        const grossWeight = checkForNull(Number(getValues('castingWeight'))) + checkForNull(dataToSend?.burningValue) + lostSum
        const finishedWeight = checkForNull(Number(getValues('finishedWeight')))

        if (finishedWeight !== 0) {

            scrapWeight = checkForNull(castingWeight) - checkForNull(finishedWeight) //FINAL Casting Weight - FINISHED WEIGHT
            setValue('scrapWeight', checkForDecimalAndNull(scrapWeight, getConfigurationKey().NoOfDecimalForInputOutput))

        }

        const recovery = checkForNull(Number(getValues('recovery')) / 100)
        const rmCost = checkForNull(grossWeight) * checkForNull(rmRowData.RMRate) //FINAL GROSS WEIGHT - RMRATE
        const scrapCost = checkForNull(checkForNull(scrapWeight) * checkForNull(rmRowData.ScrapRate) * recovery)
        const materialCost = checkForNull(rmCost) - checkForNull(scrapCost)
        const updatedValue = dataToSend
        updatedValue.totalGrossWeight = grossWeight
        updatedValue.scrapWeight = scrapWeight
        updatedValue.rmCost = rmCost
        updatedValue.scrapCost = scrapCost
        updatedValue.materialCost = materialCost
        setDataToSend(updatedValue)
        setValue('grossWeight', checkForDecimalAndNull(grossWeight, getConfigurationKey().NoOfDecimalForInputOutput))
        setValue('scrapWeight', checkForDecimalAndNull(scrapWeight, getConfigurationKey().NoOfDecimalForInputOutput))
        setValue('rmCost', checkForDecimalAndNull(rmCost, getConfigurationKey().NoOfDecimalForPrice))
        setValue('scrapCost', checkForDecimalAndNull(scrapCost, getConfigurationKey().NoOfDecimalForPrice))
        setValue('materialCost', checkForDecimalAndNull(materialCost, getConfigurationKey().NoOfDecimalForPrice))
        setLostWeight(lostSum)
    }

    const calculateShotWeight = () => {
        const castingWeight = checkForNull(Number(getValues('castingWeight')))
        const cavity = checkForNull(Number(getValues('cavity')))
        const yieldPercent = checkForNull(Number(getValues('yieldPercent')))

        let shotWeight = 0
        if (cavity > 0 && yieldPercent > 0) {
            // Shot weight = Casting weight * cavity / Yield %
            shotWeight = (castingWeight * cavity) / (yieldPercent / 100)
        }

        const formattedShotWeight = checkForDecimalAndNull(shotWeight, getConfigurationKey().NoOfDecimalForInputOutput)
        const currentShotWeight = getValues('shotWeight')

        // Update dataToSend with calculated value
        const updatedValue = dataToSend
        updatedValue.shotWeight = shotWeight
        setDataToSend(updatedValue)

        // Only update form field if value has changed to prevent infinite loop
        if (formattedShotWeight !== currentShotWeight) {
            setValue('shotWeight', formattedShotWeight)
        }
    }

    const burningValue = () => {
        // Use full precision values for calculation
        const shotWeight = (isHpdcOrLpdc && isAutoCalculateShotWeight) ? (dataToSend.shotWeight || 0) : Number(getValues('shotWeight'))
        const burningPercent = Number(getValues('burningPercent') || 0)
        const cavity = Number(getValues('cavity') || 0)

        // Calculate with full precision
        let burningVal = 0
        if (cavity > 0) {
            burningVal = (shotWeight / cavity) * (burningPercent / 100)
        }

        const formattedBurningValue = checkForDecimalAndNull(burningVal, getConfigurationKey().NoOfDecimalForInputOutput)
        const currentBurningValue = getValues('burningValue')

        // Store full precision value in dataToSend
        const updatedValue = dataToSend
        updatedValue.burningValue = burningVal
        setDataToSend(updatedValue)

        // Only update display if value has changed to prevent infinite loop
        if (formattedBurningValue !== currentBurningValue) {
            setValue('burningValue', formattedBurningValue)
        }
    }

    const handleToggleChange = () => {
        // Reset Shot Weight and Yield fields when toggle changes
        setValue('shotWeight', '')
        setValue('yieldPercent', '')
        setValue('burningValue', '')
        const updatedValue = dataToSend
        updatedValue.shotWeight = 0
        updatedValue.burningValue = 0
        setDataToSend(updatedValue)
        setIsAutoCalculateShotWeight(!isAutoCalculateShotWeight)
    }

    const onSubmit = debounce(handleSubmit((values) => {
        setIsDisable(true)
        let obj = {}
        obj.LayoutType = activeTab === '1' ? 'GDC' : activeTab === '2' ? 'LPDC' : 'HPDC'
        obj.DieCastingWeightCalculatorId = WeightCalculatorRequest && WeightCalculatorRequest.DieCastingWeightCalculatorId ? Number(WeightCalculatorRequest.DieCastingWeightCalculatorId) : 0
        obj.BaseCostingIdRef = item.CostingId
        obj.RawMaterialIdRef = rmRowData.RawMaterialId
        obj.CostingRawMaterialDetailsIdRef = rmRowData.RawMaterialDetailId
        // Auto-calculated fields use dataToSend when isHpdcOrLpdc and isAutoCalculateShotWeight is true, otherwise use getValues
        obj.ShotWeight = (isHpdcOrLpdc && isAutoCalculateShotWeight) ? Number(dataToSend.shotWeight || 0) : Number(getValues('shotWeight') || 0)
        obj.NumberOfCavity = Number(getValues('cavity') || 0)
        obj.YieldPercent = Number(getValues('yieldPercent') || 0)
        obj.IsAutoCalculateShotWeight = isAutoCalculateShotWeight
        obj.BurningPercentage = Number(getValues('burningPercent') || 0)
        obj.BurningValue = Number(dataToSend.burningValue || 0)
        obj.MachiningScrapWeight = Number(getValues('machiningScrapWeight') || 0)
        obj.CastingWeight = Number(getValues('castingWeight') || 0)
        obj.RecoveryPercentage = Number(getValues('recovery') || 0)
        obj.GrossWeight = Number(dataToSend.totalGrossWeight || 0)
        obj.FinishWeight = Number(getValues('finishedWeight') || 0)
        obj.ScrapWeight = Number(dataToSend.scrapWeight || 0)
        obj.RMCost = Number(dataToSend.rmCost || 0)
        obj.ScrapCost = Number(dataToSend.scrapCost || 0)
        obj.RawMaterialCost = Number(dataToSend.materialCost || 0)
        obj.LoggedInUserId = loggedInUserId()
        let tempArr = []
        tableVal && tableVal.map(item => (
            tempArr.push({ LossOfType: Number(item.LossOfType), LossPercentage: Number(item.LossPercentage), LossWeight: Number(item.LossWeight), CostingCalculationDetailId: "0" })
        ))
        obj.LossOfTypeDetails = tempArr
        obj.NetLossWeight = Number(lostWeight)

        dispatch(saveRawMaterialCalculationForDieCasting(obj, res => {
            setIsDisable(false)
            if (res.data.Result) {
                obj.WeightCalculationId = res.data.Identity
                Toaster.success("Calculation saved successfully")
                props.toggleDrawer('', obj)
            }
        }))

    }), 500)


    const onCancel = () => {
        props.toggleDrawer('')
    }

    const handleKeyDown = function (e) {
        if (e.key === 'Enter' && e.shiftKey === false) {
            e.preventDefault();
        }
    };

    return (
        <Fragment>
            <Row>

                <form noValidate className="form"
                    onKeyDown={(e) => { handleKeyDown(e, onSubmit.bind(this)); }}>
                    <Col md="12">
                        <div className="costing-border px-4">
                            <Row>
                                <Col md="12" className={'mt25'}>
                                    <div className="header-title">
                                        <h5>{'Input Weight Calculator:'}</h5>
                                    </div>
                                </Col>
                            </Row>

                            <Row className={''}>
                                <Col md="4">
                                    <TextFieldHookForm
                                        label={`Casting Weight${activeTab === '3' ? ` (before machining)` : `(kg)`}`}
                                        name={'castingWeight'}
                                        Controller={Controller}
                                        control={control}
                                        register={register}
                                        mandatory={true}
                                        rules={{
                                            required: true,
                                            validate: { number, checkWhiteSpaces, decimalAndNumberValidation },
                                        }}
                                        handleChange={() => { }}
                                        defaultValue={''}
                                        className=""
                                        customClassName={'withBorder text-nowrap'}
                                        errors={errors.castingWeight}
                                        disabled={props.isEditFlag ? false : true}
                                    />
                                </Col>
                                {isHpdcOrLpdc &&
                                    <>
                                        <Col md="3">
                                            <TextFieldHookForm
                                                label={`No. of Cavity`}
                                                name={'cavity'}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={false}
                                                rules={{
                                                    required: false,
                                                    validate: { number, checkWhiteSpaces, decimalAndNumberValidation },
                                                }}
                                                handleChange={() => { }}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.cavity}
                                                disabled={props.isEditFlag ? false : true}
                                            />
                                        </Col>
                                        <Col md="4" className="d-flex align-items-center">
                                            <label htmlFor="auto-calculate-switch" className="normal-switch mb-0 mr-3">
                                                <Switch
                                                    onChange={handleToggleChange}
                                                    checked={isAutoCalculateShotWeight}
                                                    disabled={props.isEditFlag ? false : true}
                                                    onColor="#4DC771"
                                                    onHandleColor="#ffffff"
                                                    offColor="#FC5774"
                                                    id="auto-calculate-switch"
                                                    height={24}
                                                    width={48}
                                                    className={isAutoCalculateShotWeight ? "active-switch" : "inactive-switch"}
                                                />
                                            </label>
                                            {isAutoCalculateShotWeight && (
                                                <TextFieldHookForm
                                                    label={`Yield (%)`}
                                                    name={'yieldPercent'}
                                                    Controller={Controller}
                                                    control={control}
                                                    register={register}
                                                    mandatory={true}
                                                    rules={{
                                                        required: 'Yield % is required',
                                                        validate: { number, checkWhiteSpaces, percentageLimitValidation },
                                                        max: {
                                                            value: 100,
                                                            message: 'Percentage cannot be greater than 100'
                                                        },
                                                    }}
                                                    handleChange={() => { }}
                                                    defaultValue={''}
                                                    className=""
                                                    customClassName={'withBorder'}
                                                    errors={errors.yieldPercent}
                                                    disabled={props.isEditFlag ? false : true}
                                                />
                                            )}
                                        </Col>
                                    </>}
                            </Row>
                            {isHpdcOrLpdc &&
                                <Row className={''}>
                                    <Col md="3" >
                                        {isAutoCalculateShotWeight && (
                                            <TooltipCustom disabledIcon={true} id={'shot-weight-nonferrous'} tooltipText={"Shot Weight = (Casting Weight * No. of Cavity) / (Yield % / 100)"} />
                                        )}
                                        <TextFieldHookForm
                                            label={`Shot Weight(Kg)`}
                                            name={'shotWeight'}
                                            Controller={Controller}
                                            control={control}
                                            id={isAutoCalculateShotWeight ? 'shot-weight-nonferrous' : ''}
                                            register={register}
                                            mandatory={false}
                                            rules={{
                                                required: false,
                                                validate: { number, checkWhiteSpaces, decimalAndNumberValidation },
                                            }}
                                            handleChange={() => { }}
                                            defaultValue={''}
                                            className=""
                                            customClassName={'withBorder'}
                                            errors={errors.shotWeight}
                                            disabled={isAutoCalculateShotWeight ? true : (props.isEditFlag ? false : true)}
                                        />
                                    </Col>
                                    <Col md="3" >
                                        <TextFieldHookForm
                                            label={`Burning (%)`}
                                            name={'burningPercent'}
                                            Controller={Controller}
                                            control={control}
                                            register={register}
                                            mandatory={false}
                                            rules={{
                                                required: false,
                                                validate: { number, checkWhiteSpaces, percentageLimitValidation },
                                                max: {
                                                    value: 100,
                                                    message: 'Percentage cannot be greater than 100'
                                                },
                                            }}
                                            handleChange={() => { }}
                                            defaultValue={''}
                                            className=""
                                            customClassName={'withBorder'}
                                            errors={errors.burningPercent}
                                            disabled={props.isEditFlag ? false : true}
                                        />
                                    </Col>
                                    <Col md="3">
                                        <TooltipCustom disabledIcon={true} id={'buring-nonferrous'} tooltipText={"Burning Value = (Shot Weight / No. of Cavity) * (Burning Percentage / 100)"} />
                                        <TextFieldHookForm
                                            label={`Burning Value`}
                                            name={'burningValue'}
                                            Controller={Controller}
                                            control={control}
                                            id={'buring-nonferrous'}
                                            register={register}
                                            mandatory={false}
                                            handleChange={() => { }}
                                            defaultValue={''}
                                            className=""
                                            customClassName={'withBorder'}
                                            errors={errors.burningValue}
                                            disabled={true}
                                        />
                                    </Col>
                                </Row>
                            }

                            <LossStandardTable
                                dropDownMenu={nonFerrousDropDown}
                                CostingViewMode={props.CostingViewMode}
                                calculation={calculateRemainingCalculation}
                                weightValue={Number(getValues('castingWeight'))}
                                netWeight={WeightCalculatorRequest && WeightCalculatorRequest.NetLossWeight !== null ? WeightCalculatorRequest.NetLossWeight : ''}
                                sendTable={WeightCalculatorRequest && WeightCalculatorRequest.LossOfTypeDetails !== null ? WeightCalculatorRequest.LossOfTypeDetails : []}
                                tableValue={tableData}
                                isLossStandard={false}
                                LossDropDown={LossDropDown}
                                isPlastic={false}
                                isNonFerrous={true}
                                isFerrous={false}
                                NonFerrousErrors={errors}
                            />

                            <Row className={'mt25'}>
                                <Col md="3" >
                                    <TooltipCustom disabledIcon={true} id={'gross-weight-nonferrous'} tooltipText={`Gross Weight = (Casting Weight ${isHpdcOrLpdc ? '+ Burning Value' : ''} + Net Loss Weight)`} />
                                    <TextFieldHookForm
                                        label={`Gross Weight(Kg)`}
                                        name={'grossWeight'}
                                        id={'gross-weight-nonferrous'}
                                        Controller={Controller}
                                        control={control}
                                        register={register}
                                        mandatory={false}
                                        handleChange={() => { }}
                                        defaultValue={''}
                                        className=""
                                        customClassName={'withBorder'}
                                        errors={errors.grossWeight}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md="3" >
                                    <TextFieldHookForm
                                        label={`Finished Weight(Kg)`}
                                        name={'finishedWeight'}
                                        Controller={Controller}
                                        control={control}
                                        register={register}
                                        mandatory={true}
                                        rules={{
                                            required: true,
                                            validate: { number, checkWhiteSpaces, decimalAndNumberValidation },
                                            max: {
                                                value: getValues('castingWeight'),
                                                message: 'Finish weight should not be greater than casting weight.'
                                            },

                                        }}
                                        handleChange={() => { }}
                                        defaultValue={''}
                                        className=""
                                        customClassName={'withBorder'}
                                        errors={errors.finishedWeight}
                                        disabled={props.isEditFlag ? false : true}
                                    />
                                </Col>

                                <Col md="3">
                                    <TooltipCustom disabledIcon={true} id={'scrap-weight-nonferrous'} tooltipText={'Scrap Weight = (Casting Weight - Finished Weight)'} />
                                    <TextFieldHookForm
                                        label={`Scrap Weight(Kg)`}
                                        name={'scrapWeight'}
                                        id={'scrap-weight-nonferrous'}
                                        Controller={Controller}
                                        control={control}
                                        register={register}
                                        mandatory={false}
                                        handleChange={() => { }}
                                        defaultValue={WeightCalculatorRequest &&
                                            WeightCalculatorRequest.ScrapWeight !== undefined
                                            ? WeightCalculatorRequest.ScrapWeight
                                            : ''}
                                        className=""
                                        customClassName={'withBorder'}
                                        errors={errors.scrapWeight}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md="3">
                                    <TextFieldHookForm
                                        label={`Scrap Recovery (%)`}
                                        name={'recovery'}
                                        Controller={Controller}
                                        control={control}
                                        register={register}
                                        mandatory={false}
                                        rules={{
                                            required: false,
                                            validate: { number, checkWhiteSpaces, percentageLimitValidation },
                                            max: {
                                                value: 100,
                                                message: 'Percentage cannot be greater than 100'
                                            },
                                        }}
                                        handleChange={() => { }}
                                        className=""
                                        customClassName={'withBorder'}
                                        errors={errors.recovery}
                                        disabled={props.isEditFlag ? false : true}
                                    />
                                </Col>
                            </Row>

                            <Row className={''}>
                                {isHpdcOrLpdc &&
                                    <>
                                        <Col md="3">
                                            <TooltipCustom disabledIcon={true} id={'-rm-cost-non-ferrous'} tooltipText={'RM Cost = (Gross Weight * RM Rate)'} />
                                            <TextFieldHookForm
                                                label={`RM Cost`}
                                                name={'rmCost'}
                                                id={'-rm-cost-non-ferrous'}
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                mandatory={false}
                                                handleChange={() => { }}
                                                defaultValue={''}
                                                className=""
                                                customClassName={'withBorder'}
                                                errors={errors.rmCost}
                                                disabled={true}
                                            />
                                        </Col>
                                    </>}
                                <Col md="3">
                                    <TooltipCustom tooltipClass='weight-of-sheet' disabledIcon={true} id={'scrap-cost-nonferrous'} tooltipText={'Scrap Cost = (Scrap Weight * Scrap Recovery Percentage * Scrap Rate / 100)'} />
                                    <TextFieldHookForm
                                        label={`Scrap Cost`}
                                        name={'scrapCost'}
                                        Controller={Controller}
                                        id={'scrap-cost-nonferrous'}
                                        control={control}
                                        register={register}
                                        mandatory={false}
                                        handleChange={() => { }}
                                        defaultValue={''}
                                        className=""
                                        customClassName={'withBorder'}
                                        errors={errors.scrapCost}
                                        disabled={true}
                                    />
                                </Col>

                                <Col md="3">
                                    <TooltipCustom disabledIcon={true} id={'net-rm-nonferrous'} tooltipText={'Net RM Cost = (Gross Weight * RM Rate - Scrap Cost)'} />
                                    <TextFieldHookForm
                                        // Confirm this name from tanmay sir
                                        label={`Net RM Cost`}
                                        name={'materialCost'}
                                        Controller={Controller}
                                        id={'net-rm-nonferrous'}
                                        control={control}
                                        register={register}
                                        mandatory={false}
                                        handleChange={() => { }}
                                        defaultValue={''}
                                        className=""
                                        customClassName={'withBorder'}
                                        errors={errors.materialCost}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>

                        </div>
                    </Col>
                    <div className="mt25 col-md-12 text-right">
                        <button
                            onClick={onCancel} // Need to change this cancel functionality
                            type="submit"
                            value="CANCEL"
                            className="reset mr15 cancel-btn"
                        >
                            <div className={'cancel-icon'}></div>
                            CANCEL
                        </button>
                        <button
                            type="button"
                            onClick={onSubmit}
                            disabled={props.CostingViewMode || isDisable ? true : false}
                            className="submit-button save-btn"
                        >
                            <div className={'save-icon'}>
                            </div>
                            {'SAVE'}
                        </button>
                    </div>
                </form>

            </Row>
        </Fragment>
    );
}

export default NonFerrous;